// Centralized data store for upcoming litter announcements
import { dogProfiles } from './dogProfiles';

export const upcomingLitters = [
  // Example entry:
  // {
  //   id: 'tonks-dume-2026-summer',
  //   title: 'Tonks & Dume Litter',
  //   parents: {
  //     mother: dogProfiles.tonks,
  //     father: dogProfiles.dume
  //   },
  //   expectedBirthDate: 'Summer 2026',
  //   expectedReadyDate: 'Winter 2026'
  // }
];
